__webpack_require__.p = "https://smartflow.dev.coor.digital/";